export { default as default } from "./views/view";